import { CSSObject } from "styled-components";

const cssObjectForLink = (
	colorHex: string | undefined,
	disabled: boolean | undefined,
	disabledColorHex: string | undefined
): CSSObject => {
	switch (disabled) {
		case true:
			return {
				color: disabledColorHex,
				textDecorationColor: disabledColorHex,
			};
		default:
			return {
				color: colorHex,
				textDecorationColor: colorHex,
			};
	}
};

export default cssObjectForLink;
